import { useEffect, useRef } from 'react'

/**
 *
 * @param value The variable whose value you want to track.
 * @returns Return the previous value of the variable you want to track.
 */
export const usePrevious = <T>(value: T) => {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
